import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import WorkoutCard from './WorkoutCard';
import { getWeeklyPlan, resetHealthGoals } from '../../services';
import Header from '../../components/common/Header';
import FooterButton from '../../components/common/FooterButton';

import ArrowRight from '../../images/health-content/arrow-right.svg';
import PageIcon from '../../images/health-content/page-icon.svg';
import ArcheryIcon from '../../images/health-content/archery-icon.svg';
import ResetWorkoutButton from '../../components/common/ResetWorkoutButton';

const Card = styled.div`
  border: 1px solid #e3e3e3;
  border-radius: 1rem;
`;

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  background: white;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  padding-bottom: 100px;
`;

function TargetCard({ title, targets }) {
  return (
    <Card className="overflow-hidden mb-9">
      <div className="bg-green-shades2 bg-opacity-10 p-4 px-4">
        <h3 className="text-sub text-body-s">
          <img src={ArcheryIcon} alt="archery-arrow" className="inline" />
          &nbsp;Goal:&nbsp;
          <span className="text-black font-medium">{title}</span>
        </h3>
      </div>
      <div className="p-4 text-caption-l">
        {targets.map((target) => (
          <p className="mb-2">
            <img
              height="16px"
              width="16px"
              src={target.icon}
              alt="heat"
              className="inline mr-2"
            />
            {target.title}: {target.value}
          </p>
        ))}
      </div>
    </Card>
  );
}

function WorkoutTracker({ tracks }) {
  return tracks.map((track, index) => (
    <div className="my-4 flex">
      <div className="flex flex-col mr-15 w-6 items-center">
        <div
          className={`border-4 border-${
            track.current ? 'primary' : 'customC4C4C4'
          } rounded-full `}
          style={{ height: '20px', width: '18.594px' }}
        ></div>
        {tracks.length - 1 !== index && (
          <div
            className={`h-100 rounded border border-${
              tracks[index + 1].current ? 'primary' : 'customC4C4C4'
            } w-0 mt-2`}
          ></div>
        )}
      </div>
      <WorkoutCard
        index={index}
        heading={track.title}
        label={track.label}
        targets={track.targets}
      />
    </div>
  ));
}

export default function StepWeeklyPlan(props) {
  const history = useHistory();
  const { from } = props.location.state;

  function continueOnboarding() {
    if (from) {
      return history.push('/hcp/view-workout-mealplan', {
        pwa: true,
        tabName: 'Workout',
      });
    }
    history.push('/health-content/fitness-home');
  }

  const { authToken } = useSelector((state) => state.user);

  const [plan, setPlan] = useState([]);
  const [targetCard, setTargetCard] = useState(null);
  const [loading, setLoading] = useState(true);

  const getPlan = async () => {
    try {
      const data = await getWeeklyPlan(authToken);
      setPlan(data.planDetails.timeLine);
      setTargetCard(data.planDetails.goalCard);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching weekly plan:', error);
    }
  };

  useEffect(() => {
    getPlan();
  }, []);

  return (
    <OuterContainer>
      <Header title="Your workout plan">
        <ResetWorkoutButton setLoading={setLoading} />
      </Header>
      <BodyContainer>
        {!loading && (
          <div>
            <TargetCard {...targetCard} />
            <WorkoutTracker tracks={plan} />
          </div>
        )}
      </BodyContainer>
      <FooterButton buttonText="Continue" onClick={continueOnboarding} />
    </OuterContainer>
  );
}
